import Vue from 'vue'
import Router from 'vue-router'
import Adminizer from '@/components/Adminizer'
import Devices from '@/components/Devices'
import Login from '@/components/Login'
import Sites from '@/components/Sites'
import Users from '@/components/Users'
//import Tests from '@/components/Tests'
import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/adminizer',
      name: 'Adminizer',
      component: Adminizer,
      meta: { requiresAuth: true }
    },
    {
      path: '/devices/:site',
      name: 'Devices',
      component: Devices,
      meta: { requiresAuth: true }
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/sites',
      name: 'Sites',
      component: Sites,
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: { requiresAuth: true }
    },
    {
      path: '/users/:uid',
      name: 'UserEdit',
      component: Users,
      meta: { requiresAuth: true }
    }
    /*,
    {
      path: '/tests',
      name: 'Tests',
      component: Tests,
      meta: { requiresAuth: true }
    }*/
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(rec => rec.meta.requiresAuth && !firebase.auth().currentUser)) {
    next({name: 'Login'})
  } else if(to.name == 'Login' && firebase.auth().currentUser) {
    next({name: 'Sites'})
  } else { next() }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js